import { Kullanici } from "./kullanici";
import { Master } from "./master";
import { TeklifKalem } from "./teklif-kalem";

export class TeklifFiyatDegisiklik {
    id: number;
    olusturmaTarihi: Date;
    teklifKalemId: number;
    fiyat: number;
    paraBirimiId: number;
    // teklifKalem: TeklifKalem;
    kullanici: Kullanici;
    paraBirimi: Master;

    constructor(obj?: any) {
        if (obj == null) {
            return;
        }

        Object.assign(this, obj);

        if (obj.paraBirimi != null) {
            this.paraBirimi = new Master(obj.paraBirimi);
        }
    }
}
